<mat-tab-group *ngIf="profile.canEditTransactionJson">
  <mat-tab [label]="'TRANSACTION_BUILDER.FORM' | translate">
    <ng-container *ngTemplateOutlet="transactionBuilderForm"></ng-container>
  </mat-tab>

  <mat-tab [label]="'TRANSACTION_BUILDER.JSON_EDITOR' | translate">
    <div class="mt3 mb2">
      <lib-button class="mr2" weight="secondary" type="button" (click)="onInsertTransactionData()">
        {{'TRANSACTION_BUILDER.INSERT_TRANSACTION_DATA' | translate}}
      </lib-button>

      <lib-button
        weight="primary"
        type="button"
        [disabled]="!jsonEditorRef?.isValidJson()"
        (click)="onRunJson()"
      >
        {{'TRANSACTION_BUILDER.RUN_JSON' | translate}}
      </lib-button>
    </div>

    <json-editor
      class="app-transaction-builder-json-editor"
      [options]="jsonEditorOptions"
      [formControl]="jsonEditorFormControl"
    ></json-editor>
  </mat-tab>

  <mat-tab [label]="'TRANSACTION_BUILDER.CONFIG' | translate">
    <json-editor
      class="app-transaction-builder-json-editor"
      [options]="configJsonEditorOptions"
      [data]="envConfig.data"
    ></json-editor>
  </mat-tab>
</mat-tab-group>

<ng-container *ngIf="!profile.canEditTransactionJson">
  <ng-container *ngTemplateOutlet="transactionBuilderForm"></ng-container>
</ng-container>

<ng-template #transactionBuilderForm>
  <div class="flex flex-wrap justify-between items-center mb2 mt3">
    <h2 class="app-content-heading my0">{{'TRANSACTION_BUILDER.NEW_TRANSACTION' | translate}}</h2>

    <div class="flex">
      <div class="pr1">
        <lib-button
          *ngIf="displayDevControls()"
          weight="tertiary"
          type="button"
          (click)="onPrepopulateForm()"
        >
          {{'TRANSACTION_BUILDER.PREFILL_FORM' | translate}}
        </lib-button>
      </div>

      <div class="relative overflow-hidden pl1">
        <app-button-file-input (fileChange)="onDataImport($event)">
          <lib-button weight="tertiary" type="button" icon="cloud_upload">
            {{'TRANSACTION_BUILDER.DATA.IMPORT' | translate}}
          </lib-button>
        </app-button-file-input>
      </div>
    </div>
  </div>

  <form class="col-12 pt1" [formGroup]="formGroup">
    <mat-card class="app-form-card app-form-card--lower-bottom mb2">
      <h3 class="app-form-section-heading mb1">
        {{'TRANSACTION_BUILDER.TRANSACTION_TITLE' | translate}}
      </h3>

      <mat-form-field class="col-12 pr4 border-box">
        <input matInput formControlName="name" />
        <mat-error
          ><app-input-errors [control]="formGroup.get('name')"></app-input-errors
        ></mat-error>
      </mat-form-field>
    </mat-card>

    <mat-card class="app-form-card mb2">
      <div class="mb3">
        <app-client-form-section
          [clientsFormArray]="clientsFormArray"
          [canAddClient]="profile.canAddClient"
          [canRemoveClients]="profile.canRemoveClient"
          [canSetClientIdAutoIncrement]="profile.canSetClientIdAutoIncrement"
          [autoIncrementClientId]="transactionData.autoIncrementClientId"
          (addClient)="onAddClient()"
          (removeClient)="onRemoveClientCard($event)"
          (clientIdAutoIncrementChange)="onClientIdAutoIncrementChange($event)"
        ></app-client-form-section>
      </div>

      <app-invoking-user-section
        [formGroup]="formGroup.get('invokingUser')"
      ></app-invoking-user-section>
    </mat-card>

    <mat-card class="app-form-card mb2">
      <app-document-form-section
        [formGroup]="formGroup.get('documents')"
        [clients]="clientsFormArray.value | filterCompleteClients: transactionData.autoIncrementClientId"
        [documentsData]="transactionData.documentsData"
        [signFieldsByDocument]="transactionData.signFieldsByDocument"
        [canUploadFiles]="profile.canUploadFiles"
        [canRemoveFiles]="profile.canRemoveFiles"
        [canSelectDefaultSigType]="profile.canSelectDefaultSigType"
        [canSelectGlobalSigType]="profile.canSelectGlobalSigType"
        [canEditDocSigners]="profile.canEditDocSigners"
        (documentsSelected)="onDocumentsSelected($event)"
        (editSignFields)="onEditSignFields($event)"
        (removeDocument)="onRemoveDocument($event)"
        (changeDefaultSigType)="onDefaultSigTypeChange($event)"
        (changeGlobalSigType)="onGlobalSigTypeChange($event)"
        (documentSwap)="onDocumentSwap($event)"
      ></app-document-form-section>
    </mat-card>
  </form>

  <div class="flex justify-between mt3">
    <div>
      <app-split-button
        class="app-save-transaction-btn mr2"
        color="accent"
        [disabled]="!(transactionData | isTransactionDataComplete: formGroup: profile)"
        type="submit"
        (defaultAction)="onSaveTransaction(true)"
        (action)="onSaveAction($event)"
      >
        <span defaultAction>{{'TRANSACTION_BUILDER.SAVE_AND_RUN' | translate}}</span>
        <ng-template appSplitButtonAction="save">{{'COMMON.SAVE' | translate}}</ng-template>
        <ng-template appSplitButtonAction="export"
          >{{'TRANSACTION_BUILDER.DATA.EXPORT' | translate}}</ng-template
        >
      </app-split-button>

      <lib-button weight="secondary" type="button" class="btn-medium" (click)="resetForm()">
        {{'COMMON.CANCEL' | translate}}
      </lib-button>
    </div>

    <div>
      <lib-button
        *ngIf="displayDevControls()"
        weight="tertiary"
        type="button"
        [disabled]="!(transactionData | isTransactionDataComplete: formGroup: profile)"
        (click)="onCaptureFormData()"
      >
        {{'TRANSACTION_BUILDER.DATA.REMEMBER' | translate}}
      </lib-button>
    </div>
  </div>
</ng-template>
